module.exports = __webpack_public_path__ + "static/media/CRW_1731.19810a5a.jpg";